<template>
  <div class="payment-create main-content">
    <form action="" @submit.prevent="submitPrepaymentRequestData">
      <div class="page-header">
        <h3 class="page-title">{{ $t('prepayments.invoice_payment_request') }}</h3>
        <ol class="breadcrumb">

          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/super-admin/dashboard" >{{ $t('general.home') }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link v-if="$route.name === 'preapproved.invoice.verified'" slot="item-title" to="/super-admin/preapproved-invoices" >{{ $tc('preapproved_invoices.invoice', 2) }}</router-link>
            <router-link v-else slot="item-title" to="/super-admin/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
          </li>

          <li class="breadcrumb-item">{{ $t('prepayments.invoice_payment_request') }}</li>
        </ol>

        <div class="page-actions row">
          <div class="col-xs-2 mr-4">
            <base-button
              v-if="isRejectedButtonShow"
              :loading="isLoading"
              :outline="true"
              size="large"
              icon="times"
              color="theme"
              @click="rejectedPrepaymentRequest()"
            >
              {{ $t('general.reject') }}
            </base-button>
          </div>
          <div class="col-xs-2">
            <base-button
              v-if="isVerifiedButtonShow"
              :loading="isLoading"
              size="large"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $t('general.verify') }}
            </base-button>
          </div>
        </div>
      </div>
      <SinglePreapprovedInvoiceRow v-if="$route.name === 'preapproved.invoice.verified'" :fetchData="fetchData" />
      <SingleInvoiceRow v-else :fetchData="fetchData" />

      <div class="payment-card card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.date') }}</label><span class="text-danger"> *</span>
                <base-date-picker
                  v-model="formData.prepayment_date"
                  :calendar-button="true"
                  :disabled="true"
                  calendar-button-icon="calendar"
                />
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.prepayment_request_number') }}</label><span class="text-danger"> *</span>
                <div class="base-read-box base-read-box-field">
                  <span v-html="requestNumber"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.amount') }}</label><span class="text-danger"> *</span>
                <div class="base-read-box base-read-box-field">
                  <div v-html="$utils.formatMoney(formData.requested_amount, customerCurrency)" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.payment_mode') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.payment_method" v-html="formData.payment_method.name"/>
                  <span v-else v-html="'No Payment Mode Select'"/>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label" >{{ $t('prepayments.offer_requested_on_date') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.supplier_offer_request && formData.supplier_offer_request=='as_soon_as_possible' " v-html="'As Soon as Possible'"/>
                  <span v-else-if="formData.supplier_offer_request && formData.supplier_offer_request=='select_a_date'" v-html="formData.formattedSupplierOfferRequestDate"/>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.supplier_comment') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.supplier_comment" v-html="formData.supplier_comment"/>
                  <span v-else v-html="'No Supplier Comment'"/>
                </div>

              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.administrator_comment') }}</label>
                <base-text-area
                  v-model="formData.superAdmin_comment"
                  @input="$v.formData.superAdmin_comment.$touch()"
                />
                <div v-if="$v.formData.superAdmin_comment.$error">
                  <span v-if="!$v.formData.superAdmin_comment.maxLength" class="text-danger">{{ $t('validation.notes_maxlength') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group collapse-button-container">
                <base-button
                  :loading="isLoading"
                  icon="save"
                  color="theme"
                  type="submit"
                  class="collapse-button"
                >
                  {{ $t('prepayments.save_prepayment') }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')
export default {
  components: { MultiSelect , SingleInvoiceRow, SinglePreapprovedInvoiceRow},
  mixins: [validationMixin],
  data () {
    return {
      customerCurrency:null,
      userType:null,

      formData: {
        suggest_withholding_tax_rate:0,

        payment_number: null,
        prepayment_date: null,

        requested_amount: 0,
        payment_method: null,
        invoice_id: null,
        supplier_comment: null,
        superAdmin_comment:null,
        supplier_offer_request:null,
        formattedSupplierOfferRequestDate:null,

      },
      isLoading: false,
      isVerifiedButtonShow: true,
      isRejectedButtonShow: true,
      fetchData:[],
      percentageFormat: {
        precision: 2,
        thousand_separator: ',',
        decimal_separator: '.',
        symbol: '% '
      },
      requestNumber:null
    }
  },
  created(){
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';

    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }
    this.loadInvoice()
  },
  validations () {
    return {
      formData: {
        superAdmin_comment: {
          maxLength: maxLength(255)
        },
      },
    }
  },
  computed: {
    ...mapGetters('currency', [
      'defaultCurrencyForInput',
      'selectedPrepaymentVerified'
    ]),
    ...mapGetters('payment', [
      'paymentModes'
    ])
  },
  watch: {},
  async mounted () {
    this.$nextTick(() => {
      this.loadData()

    })
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('prepayment', [
      'fetchCreatePayment',
      'addPayment',
      'updatePayment',
      'fetchEditPaymentData',
      'createPrepaymentRequest',
      'addPrepaymentRequest',
      'editPrepaymentRequest',
      'updatePrepaymentRequest'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
     ...mapActions('LoanRequest', [
      'loanRequestStatus',
    ]),
     async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData =response.data.invoice;
      }
    },
    async loadData () {
      this.isLoading = true
      let response = await this.editPrepaymentRequest(this.$route.params.id)
      this.isLoading = false
      this.formData.supplier_comment = response.data.prepaymentRequest.supplier_comment
      this.formData.invoice_id = response.data.prepaymentRequest.invoice.id
      this.customerCurrency = response.data.prepaymentRequest.invoice.customer.currency
      this.formData.prepayment_date = moment(response.data.prepaymentRequest.prepayment_date, 'YYYY-MM-DD').toString()
      this.formData.requested_amount = response.data.prepaymentRequest.requested_amount
      this.requestNumber = response.data.request_prefix +"-"+response.data.nextRequestNumber
      this.formData.payment_method = response.data.prepaymentRequest.payment_method
      this.formData.supplier_offer_request = response.data.prepaymentRequest.supplier_offer_request
      this.formData.formattedSupplierOfferRequestDate = response.data.prepaymentRequest.formattedSupplierOfferRequestDate
      return true
    },

    async submitPrepaymentRequestData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let data = {
        id: this.$route.params.id,
        superAdmin_comment:this.formData.superAdmin_comment,
      }
      this.isRejectedButtonShow = false
      this.isLoading = true
      let response = await this.updatePrepaymentRequest(data)
      if (response.data.success) {
        if (this.userType === 'super_admin') {
          const SuperAdminData = {
            invoice_id: this.$route.params.id,
            request_level: 'Verified'
          }
          let response = await this.loanRequestStatus(SuperAdminData)
          if (this.$route.name === 'preapproved.invoice.verified') {
            this.$router.push('/super-admin/preapproved-invoices')
          } else {
            this.$router.push('/super-admin/invoices')
          }
        }
        window.toastr['success'](this.$t('prepayments.prepayment_updated_message'))
        return true
      }
      this.isLoading = false
    },
    async rejectedPrepaymentRequest(){
      const data = {
        invoice_id: this.formData.invoice_id,
        request_level:'Rejected'
      }
      this.isLoading = true
      this.isVerifiedButtonShow = false
      let response = await this.loanRequestStatus(data)
      if(response.data.success){
        if(this.userType=='super_admin'){
          this.$router.push('/super-admin/invoices')
        }
      this.isLoading = false
      window.toastr['success'](this.$tc('prepayments.prepayment_rejected_message'))
      return true
      }
    },
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
